/* tslint:disable */
/* eslint-disable */
/**
 * CheckFlow
 * CheckFlow
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CorrectiveActionResponseDto
 */
export interface CorrectiveActionResponseDto {
    /**
     * 
     * @type {number}
     * @memberof CorrectiveActionResponseDto
     */
    checkId?: number;
    /**
     * 
     * @type {number}
     * @memberof CorrectiveActionResponseDto
     */
    correctiveActionId?: number;
}

/**
 * Check if a given object implements the CorrectiveActionResponseDto interface.
 */
export function instanceOfCorrectiveActionResponseDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CorrectiveActionResponseDtoFromJSON(json: any): CorrectiveActionResponseDto {
    return CorrectiveActionResponseDtoFromJSONTyped(json, false);
}

export function CorrectiveActionResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CorrectiveActionResponseDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'checkId': !exists(json, 'checkId') ? undefined : json['checkId'],
        'correctiveActionId': !exists(json, 'correctiveActionId') ? undefined : json['correctiveActionId'],
    };
}

export function CorrectiveActionResponseDtoToJSON(value?: CorrectiveActionResponseDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'checkId': value.checkId,
        'correctiveActionId': value.correctiveActionId,
    };
}

